import React, { useEffect, useState } from 'react';
import ConfirmModal from '../../components/ui/ConfirmModal';
import { toolsService } from '../../services/toolsService';
import { friendlyError } from '../../services/agentsService';

// Confirmación para eliminar una herramienta. Muestra qué agentes la usan (los que la tienen en uso dejan de usarla en su siguiente
// mensaje) y avisa que también se borran sus versiones y su historial de ejecuciones. No se puede deshacer.
export default function DeleteToolModal({ tool, onClose, onDeleted }) {
  const [usage, setUsage] = useState(null);
  useEffect(() => {
    setUsage(null);
    if (!tool) return undefined;
    let live = true;
    toolsService.toolUsage(tool.id).then((u) => { if (live) setUsage(u); }).catch(() => { if (live) setUsage([]); });
    return () => { live = false; };
  }, [tool]);
  const inUse = (usage || []).filter((a) => a.live);
  const inDraft = (usage || []).filter((a) => !a.live && a.draft);
  return (
    <ConfirmModal open={Boolean(tool)} onClose={onClose} tone="danger" title={`Eliminar «${tool?.name || ''}»`} confirmLabel="Eliminar herramienta"
      onConfirm={async () => { try { await toolsService.deleteTool(tool.id); } catch (e) { throw new Error(friendlyError(e)); } await onDeleted(tool); }}>
      <p>Se borran la herramienta, todas sus versiones publicadas y el historial de sus ejecuciones. No se puede deshacer.</p>
      {usage === null && <p className="text-fg-faint">Revisando qué agentes la usan…</p>}
      {inUse.length > 0 && (
        <p className="rounded-lg bg-caution-soft px-3 py-2 text-fg">La usan hoy {inUse.map((a) => `«${a.name}»`).join(', ')}: dejarán de tenerla desde su siguiente mensaje. Después podrás quitarla de su sección Herramientas.</p>
      )}
      {inDraft.length > 0 && <p>La tienen asignada en el borrador {inDraft.map((a) => `«${a.name}»`).join(', ')}; ahí aparecerá como «ya no existe» y se quita con un clic.</p>}
      {usage !== null && !inUse.length && !inDraft.length && <p>Ningún agente la tiene asignada.</p>}
    </ConfirmModal>
  );
}
